export default "__VITE_ASSET__C1E0KsRx__"